"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingCategoryRecord = exports.TrackingCategoryType = exports.TrackingCategoryIcon = exports.TrackingCategoryName = exports.PredicateRecord = exports.PredicateId = exports.AmountHeuristic = exports.AmountConstant = exports.AmmountValue = exports.HeuristicType = exports.AmountType = exports.PredicateTypes = exports.TrackingCategoryFreq = exports.TrackingCategoryId = exports.BuiltinTrackingCategoryId = void 0;
const z = require("zod");
const Customer_1 = require("./Customer");
const UtilTypes_1 = require("./UtilTypes");
exports.BuiltinTrackingCategoryId = z.enum(['blacklist']);
exports.TrackingCategoryId = z.string().or(exports.BuiltinTrackingCategoryId);
exports.TrackingCategoryFreq = z.enum([
    'monthly',
    'weekly',
]);
exports.PredicateTypes = z.enum([
    'businessName',
    'transactionId',
    'expense',
]);
exports.AmountType = z.enum([
    'constant',
    'heuristic',
]);
exports.HeuristicType = z.enum([
    'default',
]);
exports.AmmountValue = z.number();
exports.AmountConstant = z.object({
    type: z.literal(exports.AmountType.enum.constant),
    config: z.object({
        value: exports.AmmountValue,
    }),
});
exports.AmountHeuristic = z.object({
    type: z.literal(exports.AmountType.enum.heuristic),
    config: z.object({
        heuristic: z.literal('default'),
    }),
});
exports.PredicateId = z.string();
exports.PredicateRecord = z.object({
    _id: exports.PredicateId,
    customerId: Customer_1.CustomerId,
    trackingCategoryId: exports.TrackingCategoryId,
    matchBy: exports.PredicateTypes,
    value: z.string(),
    created: UtilTypes_1.DateString.optional(),
});
exports.TrackingCategoryName = z.string();
exports.TrackingCategoryIcon = z.string();
exports.TrackingCategoryType = z.enum(['custom', 'saving']);
exports.TrackingCategoryRecord = z.object({
    _id: exports.TrackingCategoryId,
    customerId: Customer_1.CustomerId,
    name: exports.TrackingCategoryName,
    icon: exports.TrackingCategoryIcon,
    isEnabled: z.boolean(),
    basedOnHistoryAverage: z.boolean(),
    frequency: exports.TrackingCategoryFreq,
    defaultAmount: exports.AmountConstant.or(exports.AmountHeuristic),
    created: UtilTypes_1.DateString.optional(),
    trackingCategoryType: exports.TrackingCategoryType.optional(),
});
//# sourceMappingURL=TrackingCategory.js.map